import type { RouteObject } from "react-router-dom";

export const welcomePath = "/";

export const welcomeRoute: RouteObject = {
    path: welcomePath,
    lazy: async () => {
        const { WelcomePage } = await import("@/features/welcome/page");
        return { Component: WelcomePage };
    },
};
